import { ObjectTools } from '../tools/object-tools';
import { StorageService } from './storage.service';

export class SessionStorageService implements StorageService {
  constructor(private prefix: string) {}

  public set<A>(key: string, value: A | undefined): void {
    const fullKey = this.prefix + '.' + key;
    if (ObjectTools.isNull(value)) {
      console.debug('Removing key from sessionStorage (null): ' + fullKey);
      sessionStorage.removeItem(fullKey);
      return;
    }
    console.debug('Setting key in sessionStorage: ' + fullKey);
    sessionStorage.setItem(fullKey, JSON.stringify(value));
  }

  public get<A>(key: string): A | undefined {
    const item = sessionStorage.getItem(this.prefix + '.' + key);
    if (!item) return undefined;
    try {
      return JSON.parse(item);
    } catch {
      return undefined;
    }
  }

  public remove(key: string): void {
    const fullKey = this.prefix + '.' + key;
    console.debug('Removing key from sessionStorage: ' + fullKey);
    sessionStorage.removeItem(fullKey);
  }

  clear(): void {
    sessionStorage.clear();
  }
}
